import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postMasterRateList: (params: CommonGroupIdReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.master.setup.rate.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
              
  postMasterRateSave: (params: MasterRateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.master.setup.rate.save,
      method: 'post',
      data: paramsToFormData(params),
    }), 
    
  postMasterMovieList: (params: CommonGroupIdReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.master.setup.movie.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
              
  postMasterMovieSave: (params: MasterMovieSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.master.setup.movie.save,
      method: 'post',
      data: paramsToFormData(params),
    }), 

  postMasterLecturList: (params: CommonSearchReqDto): Promise<MasterLecturResDto> =>
    request({
      url: endpoints.master.sale.lecture.list,
      method: 'post',
      data: paramsToFormData(params),
    }),   
    
  postMasterLecturrList: (params: CommonSearchReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.master.sale.lecturer.list,
      method: 'post',
      data: paramsToFormData(params),
    }),      
    
    
};
